import { Route, Routes } from "react-router-dom";
import Main from "./components/Main";
import Home from "./components/home/Home";
import M from "materialize-css/dist/js/materialize.min.js";
import Institucional from "./components/Institucional/Institucional";
import Seguros from "./components/seguros/Seguros";
import Normativa from "./components/normativa/Normativa";
import Descargas from "./components/descargas/Descargas";
import Contacto from "./components/contacto/Contacto";
import Blog from "./components/blog/Blog";
import ConsultasReclamos from "./components/consultasReclamos/ConsultasReclamos";
import Compromiso from "./components/compromiso/Compromiso";
import ServicioDeAtencion from "./components/servicioDeAtencion/ServicioDeAtencion";
import Accidente from "./components/accidente/Accidente";
import Faq from "./components/faq/Faq";
import Rrhh from "./components/rrhh/Rrhh";
import Login from "./components/prevencion/Login";
import Cursos from "./components/prevencion/Cursos";
import MainPrevencion from "./components/prevencion/MainPrevencion";
import SignIn from "./components/prevencion/SignIn";
import Videos from "./components/prevencion/Videos";
import Cuestionario from "./components/prevencion/Cuestionario";
import PagoPoliza from "./components/polizaAutomotor/PagoPoliza";
import Credenciales from "./components/credenciales/Credenciales";
function App() {
   return (
      <div className="">
         <Routes>
         <Route path="/" element={<Main M={M}/>}>
            <Route index element={<Home M={M}/>}/>
            <Route path="institucional" element={<Institucional M={M}/>}/>
            <Route path="seguros" element={<Seguros M={M}/>}/>
            <Route path="normativa" element={<Normativa M={M}/>}/>
            <Route path="descargas" element={<Descargas M={M}/>}/>
            <Route path="contacto" element={<Contacto M={M}/>}/>
            <Route path="blog" element={<Blog M={M}/>}/>
            <Route path="consultasreclamos" element={<ConsultasReclamos M={M}/>}/>
            <Route path="compromiso" element={<Compromiso M={M}/>}/>
            <Route path="servicioDeAtencion" element={<ServicioDeAtencion M={M}/>}/>
            <Route path="accidente" element={<Accidente M={M}/>}/>
            <Route path="faq" element={<Faq M={M}/>}/>
            <Route path="rrhh" element={<Rrhh M={M}/>}/>
            <Route path="pagopoliza" element={<PagoPoliza M={M}/>}/>
            <Route path="credenciales" element={<Credenciales M={M}/>}/>
         </Route>
         <Route path="/prevencion/" element={<Login M={M}/>}>
            <Route index element={<SignIn M={M}/>}/>
            <Route path="login" element={<SignIn M={M}/>}/>
         </Route>
         <Route path="/cursos/" element={<MainPrevencion  M={M}/>}>
            <Route index element={<Cursos M={M}/>}/>
            <Route path="videos/:id" element={<Videos M={M}/>}/>
            <Route path="cuestionario/:id" element={<Cuestionario M={M}/>}/>
         </Route>
         </Routes>
      </div>
   );
}

export default App;
